export default "__VITE_ASSET__Cafi23Nl__"